var map = {
	"./marauders-map-v1-01-01.jpg": 683,
	"./marauders-map-v1-01-02.jpg": 684,
	"./marauders-map-v1-02-01.jpg": 685,
	"./marauders-map-v1-02-02.jpg": 686
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 682;